import { RequestModel } from "./models/RequestModel";
import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type ListMapRequestsRequest = {
  date: Date;
};

export type ListMapRequestsResponse = {
  requests: RequestModel[];
};

export const listMapRequests = async (request: ListMapRequestsRequest) => {
  const response = await executeApiRequest(
    () => axios.post<ListMapRequestsResponse>("/requests/map", request, { withCredentials: true }),
    false
  );
  return response?.data;
};
